export enum ProductGroup {
    Overview = "Overview",
    Information = "Information",
    ESG = "ESG",
    Features = "Features",
    FeesAndRates = "Fees & rates",
    BDM = "Find BDM",
}
